module.exports = __webpack_public_path__ + "img/19.f2774fff.svg";